import { Box, Text, ListItem, UnorderedList, Center } from "@chakra-ui/react";

export default function Literature(props) {
  return (
    <div {...props} style={{ paddingTop: "10px" }}>
      <Box
        width={{ base: "90%", md: "77%", lg: "77%" }}
        ml='auto'
        mr='auto'
        background='rgba(31, 159, 181, 0.3)'
        mt='60px'
        mb='20px'
        borderRadius={3}
      >
        <Center>
          <Text
            color='white'
            fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
            fontWeight={700}
          >
            Related Literature
          </Text>
        </Center>
        <Box
          width='91%'
          textAlign='justify'
          ml='auto'
          mr='auto'
          pt='10px'
          pb='10px'
        >
          <Text color='white' fontSize='16px'>
            Here is a list of publications you might find interesting if you
            would like to further explore the potential of artificial
            intelligence in urology. If you have any queries or comments, free
            to contact us using the form to your right!
          </Text>
          <UnorderedList color='white' fontSize='16px'>
            <ListItem>
              Darius J. Bägli, Nicolas Fernandez. Artificial Intelligence. How
              Artificial is Urology Practice Becoming? Revista Urología
              Colombiana / Colombian Urology Journal 2020; 29(01): 005-006 DOI:
              10.1055/s-0040-1709124
            </ListItem>
            <ListItem>
              <a href='https://doi.org/10.1111/bju.14852'>
                Jian Chen, Daphne Remulla, Jessica H. Nguyen, D. Aastha, Yan
                Liu, Prokar Dasgupta, Andrew J. Hung Current status of
                artificial intelligence applications in urology and their
                potential to influence clinical practice.
              </a>
            </ListItem>
            <ListItem>
              <a href='https://www.urologytimes.com/view/how-artificial-intelligence-may-reshape-urologic-practice'>
                How artificial intelligence may reshape urologic practice
              </a>
            </ListItem>
            <ListItem>
              Abbas TO, Vallasciani S, Elawad A, Elifranji M, Leslie B, Elkadhi
              A, Pippi Salle JL. Plate Objective Scoring Tool (POST); An
              objective methodology for the assessment of urethral plate in
              distal hypospadias. J Pediatr Urol. 2020 Oct;16(5):675-682. doi:
              10.1016/j.jpurol.2020.07.043. Epub 2020 Aug 5. PMID: 32830060.
            </ListItem>
            <ListItem>
              Abbas TO. The Plate Objective Scoring Tool (POST): Further
              Reflections and Extended Applications. Res Rep Urol. 2021 Nov
              11;13:783-791. doi: 10.2147/RRU.S321188. PMID: 34796132; PMCID:
              PMC8594448.
            </ListItem>
            <ListItem>
              Abbas TO, Braga LH, Spinoit AF, Salle JP. Urethral plate quality
              assessment and its impact on hypospadias repair outcomes: A
              systematic review and quality assessment. J Pediatr Urol. 2021
              Jun;17(3):316-325. doi: 10.1016/j.jpurol.2021.02.017. Epub 2021
              Feb 23. PMID: 33846072.
            </ListItem>
            <ListItem>
              Tariq Abbas LM. Hypospadias: classification and standardisation of
              terminology. BJU Int. 2018. doi:10.18591/BJUIK.0623 - DOI
            </ListItem>
          </UnorderedList>
        </Box>
      </Box>
    </div>
  );
}
